import { Position } from 'src/common-services'
import { z } from 'zod'

export enum MapStyle {
  STREETS = 'streets',
  SATELLITE = 'satellite',
  LIGHT = 'light',
  DARK = 'dark',
  // Experimental
  THREEDSATELLITE = 'threedsatellite',
  EXP1 = 'exp1',
  EXP2 = 'exp2',
  EXP3 = 'exp3',
  MAPBOX = 'mapbox',
}
export const MapStyleShema = z.nativeEnum(MapStyle)

export type MapStyleConfig = {
  showPlaces: boolean
  showPlaceLabels: boolean
  showRoadLabels: boolean
  showHighwayIdentifiers: boolean
  showTransportationLabels: boolean
  showNaturalFeatures: boolean
}

export type Bounds = {
  center: Position
  northEast: Position
  southWest: Position
}

export type ShapeDisplayProps = {
  fillColor?: string
  fillOpacity?: number
  strokeWeight?: number
  strokeColor?: string
  strokeOpacity?: number
}
